import React from "react";
import {
    Avatar,
    MenuItem,
    Typography,
    makeStyles,
} from "@material-ui/core";
import salesforceRoles from "../constants/salesforceRoles";
import useAdviceTypesString from "../hooks/useAdviceTypesString";

const useStyles = makeStyles((theme) => ({
    receiveAdvice: {
        color: theme.palette.secondary.main,
    },
    contactInfoContainer: {
        display: "flex",
        flexDirection: "column",
    },
}));

const AccountContactMenuItem = ({ dto, handleAdd }) => {

    const classes = useStyles();

    const adviceTypesString = useAdviceTypesString();

    return (
        <MenuItem
            onClick={handleAdd}
            key={dto.contactId}
        >
            <Avatar
                alt={dto.name}
                src={dto.photo}
                style={{ marginRight: "8px" }}
            />
            <div className={classes.contactInfoContainer}>
                <Typography variant="body2">{dto.name} - {dto.position}</Typography>
                {
                    dto.clientRoles?.includes(salesforceRoles.CASENEST_RECEIVE_ADVICE) &&
                    <div>
                        <Typography variant="subtitle2" className={classes.receiveAdvice}>{adviceTypesString(dto.adviceTypeIds)}</Typography>
                    </div>
                }
            </div>
        </MenuItem>
    );
}

const MuiMenuItem = React.forwardRef((props, ref) => {
    return <AccountContactMenuItem innerRef={ref} {...props} />;
});


export default MuiMenuItem;